<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="orange"
    header-text-variant="light"
    centered
    size="xl"
    v-model="open"
    :title="`Produtos do parceiro ${namePartner}`"
    :busy="loading"
    :hide-footer="true"
    empty-text="Sem produtos"
  >
  
    <product-parther-component
      :loading="loading"
      :table="table"
      :pagination="pagination"
      @search="search($event)"
      @clean="clean()"
      @getProduct="get()"
    />  

    <b-row class="d-flex justify-content-end">
      <b-button
        class="mr-3"
        @click="closeModal()"
        variant="danger"
      >
      Fechar
    </b-button>
    </b-row>
  </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import ProductPartherComponent from './ProductPartherComponent.vue';

export default {
  components: { ProductPartherComponent },
  name: 'modalAllProductPartner',
  mixins: [makeToast],

  data() {
    return {
      loading: false,
      idPartner: null,
      idShopkeeper: null,
      namePartner: '',
      searchProduct: '',
      open: false,
      pagination: {
        currentPage: 1,
        itemsPerPage: 20,
        total: 1,
      },
      table:{
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Imagem',
          },
          {
            key: 'product',
            label: 'Produto',
          },
          {
            key:'costPrice',
            label: 'Custo'
          },
          {
            key:'priceSalesFormat1',
            label: 'Venda'
          },
          {
            key:'taxRate',
            label: 'Taxa'
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
          },
          {
            key: 'brand',
            label: 'Marca',
          },
        ],
        records:[]
      },
    };
  },

  methods: {
    toggleOpen({ idPartner = null, idShopkeeper = null, name = "" }) {
      this.open = !this.open;
      this.idPartner = idPartner;
      this.idShopkeeper = idShopkeeper;
      this.namePartner = name;
      this.get();
    },
    search(event) {
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.searchProduct = event;
      this.get();
    },
    clean(){
      this.searchProduct = '';
      this.table.records = [];
      this.pagination.currentPage = 1;
      this.get();
    },
    async get() {
      if (this.loading) return;

      this.loading = true;
      this.$store.dispatch('startLoader');
      
      try { 
        const params = new URLSearchParams();
        params.append('page', this.pagination.currentPage);
        params.append('productName', this.searchProduct);
        
        const { data } = await shopkeeperAppApi.get(
          `/products/partners/get-by-partner/${this.idShopkeeper}/${this.idPartner}?${params.toString()}`);
        
        const { perPage, total } = data.data || {};
        this.pagination.itemsPerPage = perPage || 15;
        this.pagination.total = total;
        this.table.records = data.data.data;
      
      } catch {
        this.makeToast(
          'Erro',
          'Houve um ao buscar os produtos',
          'danger'
        );
      } finally {
        this.loading = false;
        this.$store.dispatch('endLoader');
      }
    },
    closeModal(){
      this.open = !this.open;
    },
  },
};
</script>
